import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Container = class Container extends Vue {
  get computedWidth() {
    return typeof this.width === 'number' ? this.width + 'px' : this.width;
  }
  get computedHeight() {
    return typeof this.height === 'number' ? this.height + 'px' : this.height;
  }
};
Container.componentName = 'Container';
__decorate([Prop()], Container.prototype, "width", void 0);
__decorate([Prop()], Container.prototype, "height", void 0);
Container = __decorate([Component({
  name: 'Container'
})], Container);
export default Container;